<template>
  <b-row>
    <b-col>
      <template v-if="loading && !description">
        <LoadingLine width="90%" />
        <LoadingLine width="70%" />
        <LoadingLine width="30%" />
      </template>
      <vue-markdown v-else :source="description" />
    </b-col>
  </b-row>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import LoadingLine from '@/elements/LoadingLine';
import BodyParts from '@/elements/BodyParts';
import Resources from '@/elements/Resources';

export default {
  name: 'ProgrammDescription',
  props: {
    description: {},
    areas: {
      default: function() {
        return [];
      },
    },
    resources: {
      default: function() {
        return [];
      },
    },
    loading: { default: false },
  },

  components: {
    LoadingLine,
    BodyParts,
    Resources,
    VueMarkdown,
  },
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/elements/ProgrammDescription.vue